import { useAuth } from 'contexts/auth';
import { StaticPDPProduct } from 'modules/product-details/types';
import { useEffect, useState } from 'react';
import { isSubscriptionEnabled } from 'utils/product';

const DEFAULT_SUBSCRIPTION_TYPES = [
  'Nassfutter',
  'Trockenfutter',
  'Frische-Menüs',
  'Snacks',
];

const DEFAULT_SUBSCRIPTION_ORDERS_COUNT = 2;

type Input = {
  product?: StaticPDPProduct;
};

/**
 * Hook to decide default purchase type
 */
const useDefaultSubscriptionFoodType = ({ product }: Input) => {
  const [isSubDefault, setIsSubDefault] = useState(false);
  const { customer } = useAuth();

  useEffect(() => {
    if (!product) {
      return;
    }
    const subscriptionEnabled = isSubscriptionEnabled(
      product.tags,
      Number(product.id)
    );

    if (!subscriptionEnabled) {
      setIsSubDefault(false);
      return;
    }
    const isIncluded = DEFAULT_SUBSCRIPTION_TYPES.includes(product.productType);

    if (
      isIncluded &&
      subscriptionEnabled &&
      (!customer || customer?.ordersCount < DEFAULT_SUBSCRIPTION_ORDERS_COUNT)
    ) {
      setIsSubDefault(true);
      return;
    }
  }, [customer, product]);

  return {
    isSubDefault,
  };
};

export default useDefaultSubscriptionFoodType;
